export enum RouteNames {
  /**
   * main
   */
  HOME = '',

  /**
   * myATD
   */
  MYATD = 'myatd',
  DASHBOARD = 'dashboard',
  BENEFITS_CENTER = 'benefit-center',
  ACTIVITY_HISTORY = 'activity-history',
  LEARNING = 'learning',
  BOOKMARKS = 'bookmarks',
  NETWORK_ACTIVITY = 'network-activity',
  USER_CONTENT = 'contributions',

  /**
   * profile
   */
  PERSONAL_INFORMATION = 'personal-information',
  SECURITY = 'security',
  MEMBERSHIP_DETAILS = 'membership-details',
  COMMUNICATION = 'communication',
  ORDERS = 'orders',
  NETWORK = 'network',
  TOPICS = 'topics',
  ENTERPRISE_ADMIN = 'enterprise-admin',

  /**
   * search
   */
  SEARCH = 'search',
  SEARCH_BOOKS = 'books',
  SEARCH_COURSES = '/search/courses',
  SEARCH_INSTANT = 'instant',

  /**
   * onboarding
   */
  PROFILE = 'profile',
  SIGN_UP = 'sign-up',
  ONBOARDING = 'onboarding',
  OB_CREATE_ACCOUNT = 'create-account',
  OB_PROFILE_BIO = 'profile-bio',
  OB_WORK = 'work',
  OB_EDUCATION = 'education',
  OB_CONTACT = 'contact',
  OB_COMMUNICATION = 'communication',
  OB_NETWORK = 'network',
  OB_TOPICS = 'topics',
  OB_MEMBER = 'member',

  /**
   * Extras
   */
  ID = 'id',
  NOT_FOUND = '404',
  ERROR = 'error',
}

const atdBaseURL = () => {
  switch (process.env.REACT_APP_HOST_ENV) {
    case 'QA':
      return 'https://qa.td.org'
    default:
      return 'https://www.td.org'
  }
}

const QAExternalRoutes = {
  SSO_REGISTER: 'https://login-pqa762.td.org/Register.aspx',
  SSO_LOGOUT: 'https://login-pqa762.td.org/SignOut',
  SSO_LOGIN: 'https://login-pqa762.td.org/api/jwt/Authenticate',
  SSO_HOME: 'https://login-pqa762.td.org',
  SSO_RECOVER_PASSWORD: 'https://login-pqa762.td.org/RecoverPassword.aspx',
  SSO_CERTIFICATION_PORTAL_HOME:
    'http://login-pqa762.td.org/jwt.aspx?pnid=2001&callbackurl=https://atd.useclarus.com/simple_sso/login',
  SSO_LIBRARY:
    'http://login-pqa762.td.org/gateway/dilogin.aspx?returl=https%3A%2F%2Fcourses-staging.td.org%2Fdiweb%2Fgateway%3Ff%3Dhttps*3A*2F*2Fcourses-staging.td.org*2Fdiweb*2Fjitlearning*2Ftg*2Fatd-elements',
  CHECKOUT_MEMBERSHIP: 'https://checkout-pqa762.td.org/membership',
  TRANSCRIPT_DOWNLOAD: `https://courses-staging.td.org/diweb/transcript/dl`,
  CHECKOUT_HOME: 'https://checkout-pqa762.td.org/',
  CM_ASSESSMENT_PERSONAL: 'https://atd-stage.suhu.us/#/assess/personal',
  CM_ASSESSMENT_PERSONAL_COMMUNICATION:
    'https://atd-stage.suhu.us/#/assess/personal/communication',
  CM_LEARNING_PLANS_GOAL: 'https://atd-stage.suhu.us/#/learning-plan/goal',
  CM_LEARNING_PLANS_GOAL_SELF_GUIDED:
    'https://atd-stage.suhu.us/#/learning-plan/goal/general-improvements/self-guided',
  CM_LEARNING_PLANS_ALL:
    'https://atd-stage.suhu.us/#/learning-plan/all-resources',
}

const UATExternalRoutes = {}
const PRODExternalRoutes = {}

export const ExternalRouteNames = {
  ATD_HOME: `${atdBaseURL()}`,
  ATD_404: `${atdBaseURL()}/404`,
  ATD_ABOUT_US: `${atdBaseURL()}/about`,
  ATD_ADVERTISE: `${atdBaseURL()}/advertise-with-us`,
  ATD_CAREERS: `${atdBaseURL()}/jobs-at-atd`,
  ATD_CERTIFICATIONS: `${atdBaseURL()}/certification`,
  ATD_CHAPTERS: `${atdBaseURL()}/members/chapters`,
  ATD_CHAPTERS_LEADER_COMMUNITY: `${atdBaseURL()}/chapters/clc`,
  ATD_CHAPTERS_LOCATOR: `${atdBaseURL()}/chapter-locator`,
  ATD_CONTRIBUTE: `${atdBaseURL()}/contribute`,
  ATD_CONFERENCES: `${atdBaseURL()}/shop/conferences`,
  ATD_COOKIE_POLICY: `${atdBaseURL()}/cookie-policy`,
  ATD_EDUCATION_SEARCH: `${atdBaseURL()}/education/search-all-programs`,
  ATD_ENTERPRISE_ADMIN: `${atdBaseURL()}/enterprise-options`,
  ATD_ENTERPRISE_HOME: `${atdBaseURL()}/enterprise-solutions`,
  ATD_EVENTS: `${atdBaseURL()}/events`,
  ATD_FAX: '1.708.299.8723',
  ATD_GLOBAL_HOME: `${atdBaseURL()}/atd-global`,
  ATD_GROUPS: `${atdBaseURL()}/groups`,
  ATD_JOIN: `${atdBaseURL()}/join-atd`,
  ATD_MAIL_CUSTOMER_CARE: 'mailto:customercare@td.org',
  ATD_MEMBERSHIP_CENTER: `${atdBaseURL()}/user/member-center`,
  ATD_MERCHANDISE: `${atdBaseURL()}/store-merchandise`,
  ATD_STORE: `${atdBaseURL()}/store`,
  ATD_PHONE_GLOBAL: 'tel://+18006282783',
  ATD_PHONE_US: 'tel://+17036838100',
  ATD_PRESS_ROOM: `${atdBaseURL()}/about/atd-press-room`,
  ATD_SHOP_CONFERENCES: `${atdBaseURL()}/shop/conferences`,
  ATD_TOS: `${atdBaseURL()}/terms-and-privacy`,
  ATD_TOS_PRIVACY: `${atdBaseURL()}/privacy-notice`,
  ATD_WEB_URL: `${atdBaseURL()}`,
  SSO_LOGIN: 'https://login.td.org/api/jwt/Authenticate',
  SSO_REGISTER: 'https://login.td.org/Register.aspx',
  SSO_LOGOUT: 'https://login.td.org/SignOut',
  SSO_HOME: 'https://login.td.org',
  SSO_CERTIFICATION_PORTAL_HOME:
    'https://login.td.org/jwt.aspx?pnid=2001&callbackurl=https://atd.useclarus.com/simple_sso/login',
  SSO_LIBRARY:
    'http://login.td.org/gateway/dilogin.aspx?returl=https%3A%2F%2Fcourses.td.org%2Fdiweb%2Fgateway%3Ff%3Dhttps*3A*2F*2Fcourses.td.org*2Fdiweb*2Fjitlearning*2Ftg*2FATD_Micro_Courses',
  CHECKOUT_HOME: 'https://checkout.td.org/',
  CHECKOUT_MEMBERSHIP: 'https://checkout.td.org/membership',
  CM_ASSESSMENT_PERSONAL: 'https://tdcapability.org/#/assess/personal',
  CM_ASSESSMENT_PERSONAL_COMMUNICATION:
    'https://tdcapability.org/#/assess/personal/communication',
  CM_LEARNING_PLANS_GOAL: 'https://tdcapability.org/#/learning-plan/goal',
  CM_LEARNING_PLANS_GOAL_SELF_GUIDED:
    'https://tdcapability.org/#/learning-plan/goal/general-improvements/self-guided',
  CM_LEARNING_PLANS_ALL:
    'https://tdcapability.org/#/learning-plan/all-resources',
  HELP_HOME_US: 'https://help.td.org/hc/en-us',
  HELP_FAQ: 'https://help.td.org/hc/en-us',
  JOBS_BANK: 'https://jobs.td.org/',
  SOCIAL_FACEBOOK: 'https://www.facebook.com/ATD',
  SOCIAL_TWITTER: 'https://twitter.com/ATD',
  SOCIAL_LINKEDIN:
    'https://www.linkedin.com/company/association-for-talent-development/',
  SOCIAL_PINTEREST: 'https://www.pinterest.ca/ATDofficial/',
  SOCIAL_INSTAGRAM: 'https://www.instagram.com/atdnational/',
  SSO_RECOVER_PASSWORD: 'https://login.td.org/RecoverPassword.aspx',
  WEBCASTS_HOME: 'https://webcasts.td.org/',
  TRANSCRIPT_DOWNLOAD: `https://courses.td.org/diweb/transcript/dl`,
  ...(process.env.REACT_APP_HOST_ENV === 'QA' && QAExternalRoutes),
  ...(process.env.REACT_APP_HOST_ENV === 'UAT' && UATExternalRoutes),
  ...(process.env.REACT_APP_HOST_ENV === 'PROD' && PRODExternalRoutes),
}
